<soft-pdf-viewer
  class="viewer"
  [document]="_document | async"
  [loading]="!(_document | async)"
></soft-pdf-viewer>
